import React from "react";
import { Pressable, Text } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { GlobalStyles } from "../style/Style";

interface Props {
    label: string;
    onClick: () => void;
    selected: boolean;
}

export const SelectOption: React.FC<Props> = ({ label, onClick, selected }) => {
    const styles = useDynamicStyles(generateStyles);
    return (
        <Pressable onPress={onClick} style={styles.option}>
            <Text style={[styles.optionText, selected && styles.selected]}>{label}</Text>
        </Pressable>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        option: {
            backgroundColor: "transparent",
            paddingHorizontal: 15,
            paddingVertical: 5,
        },
        optionText: {
            fontSize: 14,
            fontWeight: "700",
            color: () => EStyleSheet.value(GlobalStyles.DROPDOWN_TEXT),
        },
        selected: {
            color: () => EStyleSheet.value(GlobalStyles.ACCENT_COLOUR),
        },
    });
};
